<script>
export default {
    name: "AddClinicalProfileForm",

    props: {
        showModal: Boolean,
    }
}
</script>
<template>
<tail-modal :show="showModal" dimension="sm:w-11/12 md:w-1/2">
  <template v-slot:title>
    <h5 class="font-bold text-sm">Add Clinical Profile</h5>
  </template>
  <template v-slot:modal-body>
    <table class="table table-bordered">
        <thead class="bg-blue-500 text-white text-sm">
            <tr>
                <th class="p-tiny">Profile</th>
                <th class="p-tiny">Check</th>
            </tr>
        </thead>
        <tbody class="text-xs">
            <tr>
                <td class="p-tiny">
                    Last HIV test Status
                </td>
                <td class="p-tiny px-2">
                    <input type="checkbox">
                </td>
            </tr>
        </tbody>
    </table>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs mr-4" @click="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
    <button class="btn-primary btn-sm text-xs"><i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>